import {
  HeaderContainer,
  ScrollableContainer,
  Title,
  CloseIcon,
} from './styled';
import loadable from '@loadable/component';
const CompanyFeed = loadable(() => import('@/components/CompanyFeed'), {
  resolveComponent: (component) => component.CompanyFeed,
});

interface Props {
  lookup: string | null;
  show?: boolean;
  onClose?: () => void;
}

export function RecentUpdatesList(props: Props) {
  return (
    <>
      <HeaderContainer>
        <Title>Recent updates</Title>
        <button onClick={props.onClose}>
          <CloseIcon />
        </button>
      </HeaderContainer>
      <ScrollableContainer>
        <CompanyFeed
          lookup={props.lookup}
          containerSize={'sm'}
          isCompanyReport
        />
      </ScrollableContainer>
    </>
  );
}
